import * as React from "react";
const HorizentalThreedotsOff = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="6" viewBox="0 0 26 6">
  <g id="noun-menu-2082921" transform="translate(33.262 -39.898) rotate(90)">
    <g id="Group_166037" data-name="Group 166037" transform="translate(39.898 7.262)">
      <circle id="Ellipse_2" data-name="Ellipse 2" cx="3" cy="3" r="3" transform="translate(0 0)" fill="#85888a"/>
      <circle id="Ellipse_3" data-name="Ellipse 3" cx="3" cy="3" r="3" transform="translate(0 10)" fill="#85888a"/>
      <circle id="Ellipse_4" data-name="Ellipse 4" cx="3" cy="3" r="3" transform="translate(0 20)" fill="#85888a"/>
    </g>
  </g>
</svg>
);

export default HorizentalThreedotsOff;
